import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { AppDocumentLanguage } from '../AppDocumentLanguage';
import { faviconDotPath, faviconPath, useTotalBadgeCount } from '../hooks';

export const AppDocumentHeadOverrides: FC = () => {
  'use memo';

  const totalBadgeCount = useTotalBadgeCount();
  const faviconHref = totalBadgeCount > 0 ? faviconDotPath : faviconPath;

  return (
    <>
      <AppDocumentLanguage />
      <Helmet defer={false}>
        <link rel="shortcut icon" href={faviconHref} />
      </Helmet>
    </>
  );
};
